
<template>
  <section class="evento-lux">

    <!-- ===== CONTENEDOR TIPO MARCO ELEGANTE ===== -->
    <div ref="card2" class="marco-tarjeta" aria-label="Recepción">
      
      <!-- FLOR SUPERIOR DECORATIVA -->
      <img class="flor-top" src="@/assets/fll.png" alt="" />

      <!-- CONTENIDO DE LA TARJETA -->
      <div class="contenido-evento"><br><br>
        <img class="icono" src="@/assets/corona11.png" alt="" />
        
        <h3 class="titulo-script">Recepción</h3>
        
        <p class="hora">4:00 PM</p>
        
        <p class="lugar">Sanger Community <br>Center
</p>
        
        <p class="direccion">
         730 Recreation Ave, Sanger, California.
        </p>

        <a
          ref="btn2"
          class="btn-rosa"
          href="https://maps.app.goo.gl/2dHEP9cn95Xhb9YC7"
          target="_blank"
          rel="noopener"
        >
          ¿Cómo llegar?
          <span class="sheen"></span>
        </a>
      </div>

    </div>

  </section>
</template>

<script>
import { ref, onMounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {

    const card2 = ref(null)
    const btn2 = ref(null)

    const animCard = (cardEl, btnEl) => {

      const $ = gsap.utils.selector(cardEl)
      const florTop = $('.flor-top')
      const icono   = $('.icono')
      const titulo  = $('.titulo-script')
      const hora    = $('.hora')
      const lugar   = $('.lugar')
      const dir     = $('.direccion')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: cardEl,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        defaults: { ease: 'power2.out' }
      })

      tl.from(cardEl,  { opacity: 0, y: 40, duration: 0.6 })
        .from(florTop, { opacity: 0, scale: 0.8, y: -20, duration: 0.6 }, '-=0.3')
        .from(icono,   { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(titulo,  { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
        .from(hora,    { opacity: 0, x: -20, duration: 0.4 }, '-=0.3')
        .from(lugar,   { opacity: 0, x: 20, duration: 0.4 }, '-=0.4')
        .from(dir,     { opacity: 0, y: 20, duration: 0.4 }, '-=0.3')
        .from(btnEl,   { opacity: 0, scale: 0.95, duration: 0.4 }, '-=0.3')

      // Brillo del botón
      ScrollTrigger.create({
        trigger: cardEl,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 0.8, ease: 'power2.out' }
          )
        }
      })
    }

    onMounted(() => {
      animCard(card2.value, btn2.value)
    })

    return { card2, btn2 }
  }
}
</script>

<style scoped>
:root {
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux {
  min-height: 100%;
  padding: 40px 18px 20px;
  margin-top: 20px;
  display: grid;
  place-items: center;
}

/* ==================== CONTENEDOR TIPO MARCO ==================== */
.marco-tarjeta {
  position: relative;
  width: min(420px, 92vw);
  background-image: url('@/assets/75d52627f5cef26838f626d8b6b3a6ee.png'); /* Ruta a la foto de marco/plantilla */
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  padding: 80px 28px 50px; /* Padding amplio para no pisar el marco pintado */
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
}

/* FLOR SUPERIOR SOBREPUESTA */
.flor-top {
  position: absolute;
  top: -45px;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  height: auto;
  z-index: 10;
  pointer-events: none;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,0.15));
}

/* CONTENIDO INTERNO */
.contenido-evento {
  position: relative;
  z-index: 2;
  width: 100%;
}

.icono {
  width: 180px;
  height: auto;
  display: block;
  margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}

.titulo-script {
  font-family: 'CynthiaJuneJF', cursive;
  font-weight: 400;
  font-size: 58px;
  letter-spacing: .4px;
  margin: 4px 0 8px;

 color:#ffff;
}

.hora {
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}

.lugar {
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}

.direccion {
  font-family: 'padres', serif;
  font-style: italic;
  color:#ffff;
  font-size: 16px !important;
  line-height: 1.5;
  margin: 0 auto 20px;
  max-width: 90%;
}

/* ==================== BOTÓN DORADO ==================== */
.btn-rosa {
  display: inline-flex !important; 
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;

  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;

  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;

  box-shadow: 0 8px 20px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 99;
  overflow: hidden;
  opacity: 1; 
}

.btn-rosa::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));
  transform: skewX(-25deg);
}

.btn-rosa:hover::after {
  left: 150%;
  transition: all 0.6s ease;
}

@media (max-width: 380px) {
  .marco-tarjeta { padding: 60px 18px 40px; }
  .flor-top { width: 180px; top: -35px; }
  .titulo-script { font-size: 42px; }
  .hora { font-size: 20px; }
  .lugar { font-size: 18px; }
}
</style>

```





